import React from 'react';
import { Delete } from 'lucide-react';
import './OnScreenKeypad.css';

// A generous fixed estimate of the keypad's own rendered height (worst
// case: an 11-key set like digits+minus wraps to 3 key rows + 1 backspace
// row). Callers reserve this as bottom padding on mobile so the keypad
// never overlaps the field/content it belongs to.
export const KEYPAD_RESERVED_SPACE_PX = 280;

const chunk = (items, size) => {
  const rows = [];
  for (let i = 0; i < items.length; i += size) rows.push(items.slice(i, i + size));
  return rows;
};

const OnScreenKeypad = ({ keys, onKey, onBackspace, label, testid = 'onscreen-keypad' }) => {
  const rows = chunk(keys, 5);

  return (
    <div className="onscreen-keypad" role="group" aria-label={label || 'On-screen keypad'} data-testid={testid}>
      {label && <div className="onscreen-keypad__label">{label}</div>}
      <div className="onscreen-keypad__rows">
        {rows.map((row, rowIndex) => (
          <div className="onscreen-keypad__row" key={rowIndex}>
            {row.map((key) => (
              <button
                type="button"
                key={key}
                className="onscreen-keypad__key"
                data-testid={`${testid}-key-${key}`}
                onClick={() => onKey(key)}
              >
                {key}
              </button>
            ))}
          </div>
        ))}
        <div className="onscreen-keypad__row">
          <button
            type="button"
            className="onscreen-keypad__key onscreen-keypad__key--backspace"
            data-testid={`${testid}-backspace`}
            onClick={onBackspace}
            aria-label="Backspace"
          >
            <Delete size={18} aria-hidden="true" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default OnScreenKeypad;
